/**
 * FilterDropdown Component
 * ========================
 * Reusable dropdown filter with active-state styling.
 */

import React, { useState, useEffect, useRef } from 'react';

const FilterDropdown = ({ value, onChange, options }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const selectedLabel = options.find((o) => o.value === value)?.label || options[0].label;

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className={`w-full flex items-center justify-between gap-2 px-4 py-2 text-sm border rounded-lg transition-colors ${
          value
            ? 'border-primary/30 bg-primary/5 text-primary dark:border-primary/40 dark:bg-primary/10'
            : 'border-gray-300 dark:border-[#3A3C3E] bg-white dark:bg-[#242628] text-gray-700 dark:text-gray-300'
        } hover:border-primary/50`}
      >
        {selectedLabel}
        <svg className={`h-4 w-4 flex-shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {open && (
        <div className="absolute left-0 right-0 z-20 mt-1 rounded-lg border border-gray-200 dark:border-[#3A3C3E] bg-white dark:bg-[#242628] shadow-lg py-1">
          {options.map((opt) => (
            <button
              key={opt.value}
              onClick={() => { onChange(opt.value); setOpen(false); }}
              className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                value === opt.value
                  ? 'bg-primary/10 text-primary font-medium'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#2E3033]'
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
